import { useEffect, useState } from 'react';
import type { ClientSubjectIntelligence, ClientSubjectIntelligenceProvider, LoadState } from './model';

export function useClientSubjectIntelligence(provider: ClientSubjectIntelligenceProvider, accountId: string, subjectId: string, refreshKey = 0) {
  const [state, setState] = useState<LoadState>('loading');
  const [data, setData] = useState<ClientSubjectIntelligence | null>(null);
  useEffect(() => {
    let active = true;
    provider.getClientSubjectIntelligence(accountId, subjectId).then((result) => {
      if (!active) return;
      setData(result);
      setState(result ? 'ready' : 'empty');
    }).catch(() => {
      if (active) setState('error');
    });
    return () => { active = false; };
  }, [provider, accountId, subjectId, refreshKey]);
  return { state, data };
}
